<template>
  <div class="position-relative" style="padding-bottom: 40px;">
    <div class="date-container" ref="flatpickr">
      <input
      v-model="week"
      data-input
      @input="updateFilter()"
      hidden
    />
    </div>
    <div class="position-absolute" style="right: 0; bottom: 0; padding: 0 20px 10px 0;">
      <base-button size="sm" type="primary" @click="reset()">
      Restablecer
      </base-button>
    </div>
  </div>
</template>

<script>
import flatpickr from "flatpickr";
import flatpickrEs from "@/data/flatpickrEs.json";
import weekSelect from "flatpickr/dist/plugins/weekSelect/weekSelect";
import moment from "moment";
  export default {
    data() {
      return {
        week: null
      };
    },
    mounted() {
    this.picker = flatpickr(this.$refs["flatpickr"], {
        // onChange: this.updateFilter.bind(this),
        dateFormat: "Y-m-d H:i:S",
        wrap: true,
        locale: flatpickrEs,
        inline: true,
        plugins: [new weekSelect({})],
        weekNumbers: true,

      });
      this.picker.calendarContainer.classList.add("ag-custom-component-popup");
    },
    methods: {
      reset() {
        this.week = null;
        this.picker.clear()
        this.updateFilter();
      },
      updateFilter() {
        this.params.filterChangedCallback();
      },
      getModel() {
        if (this.week) {
          const refDate = moment(this.week);
          return {
            filterType: "week",
            dateFrom: refDate.startOf("week").format("YYYY-MM-DD HH:mm:ss"),
            dateTo: refDate.endOf("week").format("YYYY-MM-DD HH:mm:ss"),
            week: refDate.format("GGGG-WW")
          }
        } else {
          return undefined;
        }
      },
      setModel() {
      },
      isFilterActive() {
        return this.week ? true : false;
      },
    },
  }
</script>

<style lang="scss"> 
.hasWeeks {
  width: 400px !important;
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
}

.hasWeeks.flatpickr-calendar.inline{
  top: 0 !important;
}
</style>